import { PushSubscriptionWireCategory } from '../pwa/types';

export enum HubChannel {
  NOTIFICATIONS = 'eclipsenotifications',
  NEW_FEEDBACK = 'mcfeedbacknew',
  DREAMSOFART = 'dreamsofart',
  DREAMSOFART_INPAINT = 'dreamsofartinpaint',
  BATCH_COMPLETE = 'batchcomplete',
}

export interface LiveHubNotificationBiData {
  notification_type: string;
  notification_sender_id: string;
  typeid: number;
  itemid: number;
}

export interface LiveHubNotificationPayload {
  message: string;
  url?: string;
  bi_data: LiveHubNotificationBiData;
  push_category?: PushSubscriptionWireCategory | null;
}
